import { Table, TableBody, TableHead, TableRow, Tooltip } from '@mui/material';

import {
  ActionIconButton,
  GeneralTableBox,
  NoDataSkeleton,
  RowTableCell,
  SortableHeadTableCell,
  StatusChip,
  TableBodySkeleton,
} from '../../../common/components';
import { GROUP_TEXTS } from '../constants/materialGroupsConstants';

const MIN_TABLE_WIDTH = 980;

const COLUMNS = [
  { sortKey: 'code', label: GROUP_TEXTS.code, sx: { width: 150 } },
  { sortKey: 'name', label: GROUP_TEXTS.name, sx: { textAlign: 'left', width: 260 } },
  { sortKey: 'member_count', label: GROUP_TEXTS.members, sx: { width: 160 } },
  { label: GROUP_TEXTS.materials, sx: { textAlign: 'left' } },
  { sortKey: 'revision', label: GROUP_TEXTS.revision, sx: { width: 120 } },
  { label: GROUP_TEXTS.actions, sx: { width: 120 } },
];

/**
 * Tabla del catálogo de grupos de materiales.
 * @param {Object} props
 * @param {Array<Object>} props.groups Grupos de la página actual.
 * @param {boolean} props.isLoading Carga inicial.
 * @param {Function} props.onEdit Abre el drawer de edición.
 * @param {Function} props.onRemove Pide confirmación de baja.
 * @param {{key: string, direction: string}|null} props.sort Orden vigente.
 * @param {Function} props.onSort Recibe la columna clickeada.
 * @returns {JSX.Element}
 */
const MaterialGroupsDataTable = ({ groups, isLoading, onEdit, onRemove, sort, onSort }) => (
  <GeneralTableBox fixedLayout minTableWidth={MIN_TABLE_WIDTH}>
    <Table stickyHeader size="small">
      <TableHead>
        <TableRow>
          {COLUMNS.map((column) => (
            <SortableHeadTableCell
              key={column.label}
              sortKey={column.sortKey}
              sort={sort}
              onSort={onSort}
              sx={column.sx}
            >
              {column.label}
            </SortableHeadTableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading ? (
          <TableBodySkeleton />
        ) : groups.length ? (
          groups.map((group) => {
            const materialNames = (group.articles || []).map((article) => article.name).join(', ');
            return (
              <TableRow key={group.uuid} hover>
                <RowTableCell sx={{ fontWeight: 800 }}>{group.code}</RowTableCell>
                <RowTableCell sx={{ textAlign: 'left' }} title={group.name}>
                  {group.name}
                </RowTableCell>
                <RowTableCell>
                  <StatusChip
                    size="small"
                    color="info"
                    label={GROUP_TEXTS.membersCount((group.articles || []).length)}
                  />
                </RowTableCell>
                <RowTableCell sx={{ textAlign: 'left' }} title={materialNames}>
                  {materialNames || '-'}
                </RowTableCell>
                <RowTableCell>{group.revision}</RowTableCell>
                <RowTableCell>
                  <Tooltip title={GROUP_TEXTS.edit}>
                    <span>
                      <ActionIconButton variant="edit" onClick={() => onEdit(group)} />
                    </span>
                  </Tooltip>
                  <Tooltip title={GROUP_TEXTS.remove}>
                    <span>
                      <ActionIconButton variant="delete" onClick={() => onRemove(group)} />
                    </span>
                  </Tooltip>
                </RowTableCell>
              </TableRow>
            );
          })
        ) : (
          <NoDataSkeleton colSpan={COLUMNS.length} message={GROUP_TEXTS.empty} />
        )}
      </TableBody>
    </Table>
  </GeneralTableBox>
);

export default MaterialGroupsDataTable;
